<template>
  <div class="container-fluid">

    <div class="header-inner section-inner">
        <div class="header-navigation-wrapper">

        
            <nav class="primary-menu-wrapper" >
                <ul class="primary-menu">
                <li><a href="https://www.manuscripttest.com/">ManuscriptTest.com</a></li>
                </ul>
            </nav>

        </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'header',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-inner {
    align-items: center;
    display: flex;
    justify-content: space-between;
    
}
.section-inner {
     float: right;
     position: absolute;
     left:70%;
}


ul.primary-menu {
  
    font-size: 1.3rem;
    font-weight: 500;
    margin-right:auto;
    margin-left:auto;
   
}

.primary-menu li {
    line-height: 1.25;
 
    display: inline; 
    
}


.primary-menu a {
    color: #fff !important;
    line-height: 1.2;
    text-decoration: none;
    word-break: normal;
    word-wrap: normal;
}
.primary-menu a:hover {
    text-decoration: underline;

}

@media ( max-width: 700px ) {
    .section-inner {
        width:100%;
        left:0%;
        padding-top:5em;
    }
    .primary-menu a {
        font-size:0.8em;
    }
    .header-navigation-wrapper {
        margin-right:auto;
        margin-left:auto; 
    }
    
     a {
        position:relative;
        left:-8%;
    }
}
</style>
